export default __webpack_public_path__ + "static/media/blue-gift.1c67e59b.svg";